$(document).ready(() => {
    $('[data-payment-on-behalf-of-select-all]').click(() => {
        const checkboxes = $('[name="paymentOnBehalfOf[]"]');
        const value = $(checkboxes[0]).is(':checked');
        checkboxes.prop('checked', !value);
    });
});
